<template>
    <v-col cols="12" class="AllCompanies mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                    <h2 class="font-weight-medium font-family-1">Todas Tus Empresas</h2>

                        <v-data-iterator
                                :items="items"
                                :items-per-page.sync="itemsPerPage"
                                hide-default-footer
                        >
                            <template v-slot:header>
                                
                                <v-row align="center" class="caption">
                                    <v-col cols="6" lg="2">
                                        <v-select
                                                class="select-filter"
                                                :items="['Wallmart', 'Neocity', 'Colun', 'Nestle']"
                                                filled
                                                label="Estás Administrando"
                                                background-color="#0172C0"

                                                dark

                                        ></v-select>
                                    </v-col>
                                    <v-col cols="6" lg="2" >

                                        <v-select
                                                class="select-filter"
                                                :items="['I Region ', 'II Region', 'III Region', 'IV Region']"
                                                filled
                                                label="Ubicacion"
                                                background-color="#0172C0"
                                                dark

                                        ></v-select>
                                    </v-col>

                                
                                    <v-spacer></v-spacer>
                                    <v-col cols="12" lg="2">
                                          <v-text-field
                                            class="buscador tipo1"
                                            placeholder="Buscar en"
                                            outlined
                                            append-icon="mdi-magnify"
                                    ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" lg="1">
                                        <v-btn color="primary"
                                               raised
                                               outlined
                                               class="px-6">
                                            <v-icon>mdi-dip-switch</v-icon>
                                            filtros</v-btn>
                                    </v-col>
                                </v-row>

                            </template>
                            <template v-slot:default="props">
                                <v-row align="center" justify="center">
                                    <v-col
                                            v-for="item in props.items"
                                            :key="item.name"
                                            cols="12"
                                            
                                    >
                                        <v-card
                                            class="pa-3 elevation-0"
                                        >
                                            <v-row align="center">
                                                <v-col cols="12" lg="2">
                                                    <v-card
                                                            class="pa-4 ma-0 shadow-1 rounded-lg"
                                                            tile
                                                            height="180px"
                                                            width="180px"
                                                    >
                                                        <v-img src="@/assets/images/neocity-logo.png"
                                                               height="150px"
                                                               width="150px"
                                                               
                                                               aspect-ratio="2"
                                                               contain>
                                                        </v-img>
                                                    </v-card>
                                                </v-col>
                                                <v-col cols="12" lg="4">
                                                    <v-row class="caption">
                                                        <v-col cols="12">
                                                            <b>NEOCITY ENERGÍA - 76.859.223-7</b>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row class="caption">
                                                        <v-col class="py-0">Nombre de Fantasía</v-col>
                                                        <v-col class="py-0">Nombre de la empresa S.A</v-col>
                                                    </v-row>
                                                    <v-row class="caption">
                                                        <v-col class="py-0">Giro Comercial</v-col>
                                                        <v-col class="py-0">Energía</v-col>
                                                    </v-row>
                                                    <v-row class="caption">
                                                        <v-col class="py-0">Direccion Comercial</v-col>
                                                        <v-col class="py-0">Los militares 8659</v-col>
                                                    </v-row>
                                                    <v-row class="caption">
                                                        <v-col class="py-0">Representante Legal</v-col>
                                                        <v-col class="py-0">Marcos Cisternas</v-col>
                                                    </v-row>
                                                    <v-row class="caption">
                                                        <v-col class="py-0">Sitio Web</v-col>
                                                        <v-col class="py-0">www.neocity.cl</v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col class="pt-8" cols="12" lg="6">
                                                    
                                                    <p class="caption">
                                                        Descripción:<br>
                                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque blandit accumsan libero, facilisis interdum turpis rutrum vitae.
                                                        Duis sit amet libero vitae ligula placerat hendrerit at quis massa. Nam vulputate pretium odio mattis rutrum. n sit amet efficitur urna.
                                                        Phasellus vitae tempor magna. Etiam id pharetra ipsum. Curabitur id efficitur erat. <a class="text-underline" href="#"> Ver texto completo [+]</a>
                                                    </p>
                                                    <v-btn color="primary"
                                                           raised
                                                           outlined
                                                           class="text-capitalize px-6 mt-2">
                                                        Editar Empresa</v-btn>
                                                </v-col>
                                            </v-row>

                                        </v-card>
                                    </v-col>
                                </v-row>
                            </template>

                            <template v-slot:footer>
                                <v-row class="mt-2" align="center" justify="center">
                                    <span class="grey--text">Empresas por pagina</span>
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                    dark
                                                    text
                                                    color="primary"
                                                    class="ml-2"
                                                    v-bind="attrs"
                                                    v-on="on"
                                            >
                                                {{ itemsPerPage }}
                                                <v-icon>mdi-chevron-down</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                    v-for="(number, index) in itemsPerPageArray"
                                                    :key="index"
                                                    @click="updateItemsPerPage(number)"
                                            >
                                                <v-list-item-title>{{ number }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>

                                    <v-spacer></v-spacer>

                                    <span
                                            class="mr-4
                                    grey--text"
                                                            >
                                    Pagina {{ page }} de {{ numberOfPages }}
                                  </span>
                                    <v-btn
                                            fab
                                            dark
                                            x-small
                                            color="blue darken-3"
                                            class="mr-1"
                                            @click="formerPage"
                                    >
                                        <v-icon>mdi-chevron-left</v-icon>
                                    </v-btn>
                                    <v-btn
                                            fab
                                            x-small
                                            dark
                                            color="blue darken-3"
                                            class="ml-1"
                                            @click="nextPage"
                                    >
                                        <v-icon>mdi-chevron-right</v-icon>
                                    </v-btn>
                                </v-row>
                            </template>
                        </v-data-iterator>

                </v-card>
            </v-col>
        </v-row>

    </v-col>
</template>

<script>
    export default {
        name: 'AllCompanies',
        data: () => ({
            itemsPerPageArray: [2,4, 8, 12],
            search: '',
            filter: {},
            sortDesc: false,
            page: 1,
            itemsPerPage: 4,
            items: [
                {
                    name: 'NEOCITY ENERGÍA',
                    rut: '76.859.223-7'
                },
                {
                    name: 'NEOCITY ENERGÍA',
                    rut: '76.859.223-7'

                },
                {
                    name: 'NEOCITY ENERGÍA',
                    rut: '76.859.223-7'

                },
                {
                    name: 'NEOCITY ENERGÍA',
                    rut: '76.859.223-7'

                },
            ],
        }),
        computed: {
            numberOfPages () {
                return Math.ceil(this.items.length / this.itemsPerPage)
            },
            filteredKeys () {
                return this.keys.filter(key => key !== `Name`)
            },
        },
        methods: {
            nextPage () {
                if (this.page + 1 <= this.numberOfPages) this.page += 1
            },
            formerPage () {
                if (this.page - 1 >= 1) this.page -= 1
            },
            updateItemsPerPage (number) {
                this.itemsPerPage = number
            },
        },
        created: function () {
            this.$emit('SetcolorMenu', 'primary');
        }
    }
</script>